import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="w-full bg-white py-24 md:py-32 border-b border-neutral-100" data-id="element-68">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-69">
        <FadeIn data-id="element-70">
          <h2 className="text-2xl md:text-3xl font-medium text-neutral-900 mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-71">
            "Designed for founders, SMEs, and teams who want clarity,
            accountability, and software that actually works."
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-72">
          {[1, 2, 3].map(i => <FadeIn key={i} delay={i * 0.1} data-id="element-73">
              <div className="bg-neutral-50 p-8 rounded-2xl text-left h-full flex flex-col justify-between" data-id="element-74">
                <div className="mb-6" data-id="element-75">
                  {[1, 2, 3, 4, 5].map(star => <span key={star} className="text-neutral-900 text-sm mr-1" data-id="element-76">
                      ★
                    </span>)}
                </div>
                <p className="text-neutral-600 mb-6 leading-relaxed" data-id="element-77">
                  "The milestone approach gave us complete control over our
                  budget. We knew exactly what we were paying for at every
                  step."
                </p>
                <div data-id="element-78">
                  <p className="font-medium text-neutral-900" data-id="element-79">Client Name</p>
                  <p className="text-sm text-neutral-500" data-id="element-80">CEO, Tech Company</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}